// extracted by mini-css-extract-plugin
module.exports = {"appHeader":"AppNameHeader--appHeader--nsWDCFS","body":"AppNameHeader--body--kEppoFP","logo":"AppNameHeader--logo--UUA8Vxr","name":"AppNameHeader--name--DPpQvAi"};